const icon = "_icon_11k6c_18";
const styles = {
  icon
};
export {
  styles as default,
  icon
};
//# sourceMappingURL=InlineSpinner.module.css.js.map
